import React, { useState } from 'react';

const sizes = [
  { name: '420 x 594 mm', id: '420x594', label: 'A2' },
  { name: '420 x 420 mm', id: '420x420', label: 'A2 □' },
  { name: '300 x 420 mm', id: '300x420', label: 'A3' },
  { name: '300 x 300 mm', id: '300x300', label: 'A3 □' },
  { name: '210 x 300 mm', id: '210x300', label: 'A4' },
  { name: '210 x 210 mm', id: '210x210', label: 'A4 □' },
];

const SizeFilter = (props) => {
  const [selectedSize, setSelectedSize] = useState('');

  const handleSizeClick = (sizeId) => {
    const next = sizeId === selectedSize ? '' : sizeId;
    setSelectedSize(next);
    props.setSelectedSize(next);
  };

  return (
    <div>
      <div style={{
        display: 'grid',
        gridTemplateColumns: props.isMobileView ? 'repeat(2, 1fr)' : 'repeat(3, 1fr)',
        gap: '8px',
      }}>
        {sizes.map((size) => {
          const active = props.selectedSize === size.id;
          return (
            <button
              key={size.id}
              onClick={() => handleSizeClick(size.id)}
              style={{
                display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '2px',
                padding: '12px 8px', borderRadius: '12px', cursor: 'pointer',
                border: active ? '2px solid #161825' : '2px solid #eee',
                backgroundColor: active ? '#f8f7ff' : '#fff',
                transition: 'all 0.15s ease',
              }}
              onMouseOver={(e) => { if (!active) e.currentTarget.style.borderColor = '#ccc'; }}
              onMouseOut={(e) => { if (!active) e.currentTarget.style.borderColor = active ? '#161825' : '#eee'; }}
            >
              <span style={{ fontSize: '15px', fontWeight: 600, color: active ? '#161825' : '#333' }}>
                {size.label}
              </span>
              <span style={{ fontSize: '11px', color: '#888' }}>
                {size.name}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default SizeFilter;
